import React, { useState } from 'react';
import { UsersIcon, PercentIcon, BarChart3Icon, BrainIcon } from 'lucide-react';
const SimilarPlayers = () => {
  const [activeTab, setActiveTab] = useState('similar');
  const [mode, setMode] = useState<'stats' | 'neuro'>('stats');
  const similarPlayers = [{
    name: 'Marcus Thompson',
    photo: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1628369.png',
    similarity: 92
  }, {
    name: 'David Williams',
    photo: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1629029.png',
    similarity: 85
  }, {
    name: 'Chris Anderson',
    photo: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1629027.png',
    similarity: 78
  }, {
    name: 'Kevin Mitchell',
    photo: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1628371.png',
    similarity: 75
  }, {
    name: 'Robert Johnson',
    photo: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1629028.png',
    similarity: 73
  }];
  const compatiblePlayers = [{
    name: 'Michael Roberts',
    photo: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1630173.png',
    compatibility: 95
  }, {
    name: 'James Wilson',
    photo: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1630170.png',
    compatibility: 88
  }, {
    name: 'Anthony Davis Jr',
    photo: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1628389.png',
    compatibility: 82
  }, {
    name: 'Thomas Brown',
    photo: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1630174.png',
    compatibility: 79
  }, {
    name: 'Stephen White',
    photo: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1630175.png',
    compatibility: 76
  }];
  const neuroSimilarPlayers = [{
    name: 'Chris Anderson',
    photo: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1629027.png',
    similarity: 89,
    archetype: 'Commander'
  }, {
    name: 'Robert Johnson',
    photo: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1629028.png',
    similarity: 84,
    archetype: 'Commander'
  }, {
    name: 'Marcus Thompson',
    photo: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1628369.png',
    similarity: 79,
    archetype: 'Strategist'
  }, {
    name: 'Kevin Mitchell',
    photo: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1628371.png',
    similarity: 74,
    archetype: 'Reactor'
  }, {
    name: 'David Williams',
    photo: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1629029.png',
    similarity: 71,
    archetype: 'Strategist'
  }];
  const neuroCompatiblePlayers = [{
    name: 'James Wilson',
    photo: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1630170.png',
    compatibility: 93,
    archetype: 'Catalyst'
  }, {
    name: 'Thomas Brown',
    photo: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1630174.png',
    compatibility: 87,
    archetype: 'Anchor'
  }, {
    name: 'Michael Roberts',
    photo: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1630173.png',
    compatibility: 81,
    archetype: 'Reactor'
  }, {
    name: 'Stephen White',
    photo: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1630175.png',
    compatibility: 78,
    archetype: 'Catalyst'
  }, {
    name: 'Anthony Davis Jr',
    photo: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1628389.png',
    compatibility: 74,
    archetype: 'Anchor'
  }];
  const getColorClass = (value: number) => {
    if (value >= 90) return 'text-green-600';
    if (value >= 80) return 'text-green-500';
    if (value >= 70) return 'text-yellow-500';
    return 'text-orange-500';
  };
  const currentSimilar = mode === 'stats' ? similarPlayers : neuroSimilarPlayers;
  const currentCompatible = mode === 'stats' ? compatiblePlayers : neuroCompatiblePlayers;
  return <div className="bg-white rounded-lg shadow-md h-full w-64 flex-shrink-0" data-id="element-787">
      {/* Similar / Compatible Tabs */}
      <div className="flex border-b" data-id="element-788">
        <button onClick={() => setActiveTab('similar')} className={`flex-1 flex justify-center items-center py-3 ${activeTab === 'similar' ? 'border-b-2 border-blue-600' : ''}`} data-id="element-789">
          <UsersIcon className="w-5 h-5" data-id="element-790" />
        </button>
        <button onClick={() => setActiveTab('compatible')} className={`flex-1 flex justify-center items-center py-3 ${activeTab === 'compatible' ? 'border-b-2 border-blue-600' : ''}`} data-id="element-791">
          <PercentIcon className="w-5 h-5" data-id="element-792" />
        </button>
      </div>

      {/* Mode Toggle */}
      <div className="px-4 pt-3 pb-2" data-id="element-793">
        <div className="flex items-center bg-gray-100 rounded-lg p-0.5" data-id="element-794">
          <button onClick={() => setMode('stats')} className={`flex-1 flex items-center justify-center gap-1.5 py-1.5 rounded-md text-[11px] font-bold transition-colors ${mode === 'stats' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-400 hover:text-gray-600'}`} data-id="element-795">
            <BarChart3Icon className="w-3.5 h-3.5" data-id="element-796" />
            STATS
          </button>
          <button onClick={() => setMode('neuro')} className={`flex-1 flex items-center justify-center gap-1.5 py-1.5 rounded-md text-[11px] font-bold transition-colors ${mode === 'neuro' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-400 hover:text-gray-600'}`} data-id="element-797">
            <BrainIcon className="w-3.5 h-3.5" data-id="element-798" />
            NEURO
          </button>
        </div>
      </div>

      <div className="p-4" data-id="element-799">
        {activeTab === 'similar' ? <>
            {currentSimilar.map((player: any, index: number) => <div key={index} className="mb-4" data-id="element-800">
                <div className="flex items-start space-x-3" data-id="element-801">
                  <div className="flex-shrink-0" data-id="element-802">
                    <div className="w-16 h-16 overflow-hidden rounded-md" data-id="element-803">
                      <img src={player.photo} alt={player.name} className="w-full h-full object-cover" data-id="element-804" />
                    </div>
                  </div>
                  <div className="flex-1" data-id="element-805">
                    <div className="font-bold text-sm" data-id="element-806">{player.name}</div>
                    <div className={`text-sm font-semibold ${getColorClass(player.similarity)}`} data-id="element-807">
                      {player.similarity}%
                    </div>
                    {mode === 'stats' ? <div className="mt-1 grid grid-cols-2 gap-2 text-xs text-gray-600" data-id="element-808">
                        <div data-id="element-809">PPG: 24.5</div>
                        <div data-id="element-810">RPG: 6.2</div>
                        <div data-id="element-811">APG: 7.1</div>
                        <div data-id="element-812">FG%: 48.2</div>
                      </div> : <div className="mt-1" data-id="element-813">
                        <div className="text-[10px] text-indigo-600 font-semibold bg-indigo-50 px-1.5 py-0.5 rounded inline-block" data-id="element-814">
                          {player.archetype}
                        </div>
                      </div>}
                  </div>
                </div>
              </div>)}
            <button className="w-full bg-gray-900 text-white py-2 text-sm rounded-md mt-2" data-id="element-815">
              see more
            </button>
          </> : <>
            {currentCompatible.map((player: any, index: number) => <div key={index} className="mb-4" data-id="element-816">
                <div className="flex items-start space-x-3" data-id="element-817">
                  <div className="flex-shrink-0" data-id="element-818">
                    <div className="w-16 h-16 overflow-hidden rounded-md" data-id="element-819">
                      <img src={player.photo} alt={player.name} className="w-full h-full object-cover" data-id="element-820" />
                    </div>
                  </div>
                  <div className="flex-1" data-id="element-821">
                    <div className="font-bold text-sm" data-id="element-822">{player.name}</div>
                    <div className={`text-sm font-semibold ${getColorClass(player.compatibility)}`} data-id="element-823">
                      {player.compatibility}%
                    </div>
                    {mode === 'stats' ? <div className="mt-1 grid grid-cols-2 gap-2 text-xs text-gray-600" data-id="element-824">
                        <div data-id="element-825">PPG: 22.8</div>
                        <div data-id="element-826">RPG: 5.9</div>
                        <div data-id="element-827">APG: 6.8</div>
                        <div data-id="element-828">FG%: 46.5</div>
                      </div> : <div className="mt-1" data-id="element-829">
                        <div className="text-[10px] text-indigo-600 font-semibold bg-indigo-50 px-1.5 py-0.5 rounded inline-block" data-id="element-830">
                          {player.archetype}
                        </div>
                      </div>}
                  </div>
                </div>
              </div>)}
            <button className="w-full bg-gray-900 text-white py-2 text-sm rounded-md mt-2" data-id="element-831">
              see more
            </button>
          </>}
      </div>
    </div>;
};
export default SimilarPlayers;